import { render, staticRenderFns } from "./iconP9.vue?vue&type=template&id=4355e478&scoped=true&"
import script from "./iconP9.vue?vue&type=script&lang=js&"
export * from "./iconP9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355e478",
  null
  
)

export default component.exports